/**
 * O vocabulario da tela de Configuracoes.
 *
 * As tres abas sao ESCOPOS, e nao assuntos: cada uma responde "isto vale para quem".
 * Foi essa pergunta que a tela anterior nao respondia - ela mostrava os limites de
 * status sem dizer que eram do USUARIO logado, e quem administrava uma empresa
 * concluia, razoavelmente, que valiam para ela.
 */
export const MY_DATA_TABS = ['conta', 'empresa', 'sistema'];
/** O titulo de cada aba, e o subtitulo que diz o alcance dela no cabecalho. */
export const MY_DATA_TAB_LABELS = {
    conta: {
        label: 'Minha conta',
        /*
         * "Que valem para as suas", e nao "que voce usa para ler".
         *
         * O texto anterior descrevia o modelo antigo, em que a faixa era de quem
         * OLHAVA - cada administrador lia os colaboradores pelos limites dele. Desde
         * 17/09/2026 a faixa e de quem e medido, e estes aqui nao alcancam ninguem
         * alem da propria pessoa.
         */
        hint: 'Seus dados, sua senha e os limites que valem para as SUAS medições'
    },
    empresa: {
        label: 'Minha empresa',
        hint: 'O cadastro da empresa que você administra e os limites dos colaboradores dela'
    },
    sistema: {
        label: 'Sistema',
        hint: 'Os limites padrão, que valem para toda a plataforma'
    }
};
//# sourceMappingURL=my-data.types.js.map